import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import BrandsDirectory from './components/BrandsDirectory';
import BrandPage from './components/BrandPage';
import FindMySize from './components/FindMySize';
import SizeComparison from './components/SizeComparison';
import BodyTypeGuide from './components/BodyTypeGuide';
import BlogSection from './components/BlogSection';
import BlogPost from './components/BlogPost';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AccessibilityWidget from './components/AccessibilityWidget';
import CookieConsent from './components/CookieConsent';
import SarahChatbot from './components/SarahChatbot';
import DisclaimerPage from './components/DisclaimerPage';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import AccessibilityPage from './components/AccessibilityPage';
import ConversionPage from './components/ConversionPage';
import ConversionsDirectory from './components/ConversionsDirectory';
import BrandConversionPage from './components/BrandConversionPage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function BrandSubPage() {
  const { slug, subpath } = useParams();
  if (subpath && subpath.includes('-to-')) {
    return <BrandConversionPage />;
  }
  return <BrandPage />;
}

function AdminRoute() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tfg_token');
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => setUser(r.data))
        .catch(() => localStorage.removeItem('tfg_token'))
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  const logout = () => { localStorage.removeItem('tfg_token'); setUser(null); };

  if (checking) return <div className="min-h-screen flex items-center justify-center text-[#78716C]">Loading...</div>;
  if (!user) return <AdminLogin onLogin={setUser} />;
  return <AdminDashboard onLogout={logout} />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AccessibilityWidget />
      <div id="main-wrapper">
        <Navbar />
        <main id="main-content" role="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/brands" element={<BrandsDirectory />} />
            <Route path="/brand/:slug" element={<BrandPage />} />
            <Route path="/find-my-size" element={<FindMySize />} />
            <Route path="/compare" element={<SizeComparison />} />
            <Route path="/body-type-guide" element={<BodyTypeGuide />} />
            <Route path="/blog" element={<BlogSection />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/conversions" element={<ConversionsDirectory />} />
            <Route path="/convert/:pair" element={<ConversionPage />} />
            <Route path="/convert/:pair/:detail" element={<ConversionPage />} />
            <Route path="/brand/:slug/:subpath" element={<BrandSubPage />} />
            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <SarahChatbot />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
